import {
    VStack,
    Box,
    Text,
    Icon,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Center,
    Spinner,
} from '@chakra-ui/react';
import { HiOutlineSlash } from 'react-icons/hi2';
import { MentionPreviewViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentMentionPreviewView(
    config: ReportingViewBaseConfig
): React.FC<MentionPreviewViewProps> {
    return (props) => {
        if (props.status === 'loading') {
            return (
                <Center w="full" p={6}>
                    <Spinner size="sm" speed="1s" />
                </Center>
            );
        }
        return (
            <VStack align="start" w="full" p={5} spacing={2}>
                <Box
                    position="relative"
                    top={-0.2}
                    fontSize="3xl"
                    width="1em"
                    height="1em"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="md"
                    cursor="pointer"
                    _hover={{ bg: 'whiteAlpha.50' }}
                >
                    {props.icon.kind === 'emoji' && (
                        <Text lineHeight={1}>{props.icon.text}</Text>
                    )}
                    {props.icon.kind === 'icon' && (
                        <Icon fontSize="3xl" as={props.icon.Component} />
                    )}
                </Box>
                <VStack align="start" spacing={1} fontSize="sm" w="full">
                    {props.breadcrumb && (
                        <Breadcrumb
                            size="sm"
                            userSelect="none"
                            separator={
                                <Icon as={HiOutlineSlash} color="whiteAlpha.400" />
                            }
                            spacing={0}
                        >
                            {props.breadcrumb.items.map((item) => (
                                <BreadcrumbItem
                                    key={item.id}
                                    color="whiteAlpha.500"
                                    bg="none"
                                    minH={0}
                                    textDecor="none"
                                    fontWeight="medium"
                                >
                                    <BreadcrumbLink maxW="12rem" noOfLines={1}>
                                        {item.label}
                                    </BreadcrumbLink>
                                </BreadcrumbItem>
                            ))}
                        </Breadcrumb>
                    )}
                    <Text fontWeight="semibold" color="whiteAlpha.900" noOfLines={1}>
                        {props.title}
                    </Text>
                    {props.block.isLoading && (
                        <Center w="full" p={2}>
                            <Spinner size="sm" speed="1s" color="whiteAlpha.500" />
                        </Center>
                    )}
                    {!props.block.isLoading && (
                        <Text color="whiteAlpha.700" noOfLines={3} fontSize="xs">
                            {props.block.description}
                        </Text>
                    )}
                </VStack>
            </VStack>
        );
    };
}
